<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md9, lg8, text-xs-center style="max-width: 1024px; margin: auto;")
          v-card(flat)
            breadcrumb(back='page7-1')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero contratar mi Crédito Hipotecario!
            v-card-text.text-xs-center.label16tt.withDivider.mb-4
              | SELECCIONA
            v-card-text.text-xs-center.titulo18Reg.pt-0
              b ¡Descubre en tres pasos simples si estás list@ para contratar un Crédito Hipotecario!
            v-layout(row, wrap)
              v-flex(xs12, md4, my-4)
                v-card(flat, color='grey lighten-4', height='430')
                  v-layout(row, justify-center)
                    v-flex.pa-0.ma-0(text-xs-right)
                      span.card_check.cardCheck(v-if='this.$parent.steps_calc.step1')
                        v-icon.pt-3.pr-3(color='white') fas fa-check
                  v-card-media(src='assets/TCH-L2-7-8-9-Pagina1A-imagen1.jpg', height='146px')
                  v-card-title.titulo18Reg.text-xs-left.px-3
                    | 1. Valida tus requerimientos
                  v-card-text.text-xs-left.parrafo14Book.px-3.py-0 
                    | Hay una serie de requerimientos personales básicos que debes cubrir.
                v-layout.pb-4.btn_cards(row, justify-center, align-baseline)
                  v-btn.btn(color='secondary', @click.prevent="nextPage( 'page8-1') ") Validar
              v-flex(xs12, md4, my-4)
                v-card(flat, color='grey lighten-4', height='430')
                  v-layout(row, justify-center)
                    v-flex.pa-0.ma-0(text-xs-right)
                      span.card_check.cardCheck(v-if='this.$parent.steps_calc.step2')
                        v-icon.pt-3.pr-3(color='white') fas fa-check
                  v-card-media(src='assets/TCH-L2-7-8-9-Pagina1A-imagen2.jpg', height='146px')
                  v-card-title.titulo18Reg.text-xs-left.px-3
                    | 2. Valida los requerimientos del inmueble
                  v-card-text.text-xs-left.parrafo14Book.px-3.py-0 
                    | Conoce los requisitos del inmueble.
                v-layout.pb-4.btn_cards(row, justify-center, align-baseline)
                  v-btn.btn(color='secondary', :disabled='!this.$parent.steps_calc.step1', @click.prevent="nextPage( 'page8-2')") Validar
              v-flex(xs12, md4, my-4)
                v-card(flat, color=' grey lighten-4 ', height='430')
                  v-layout(row, justify-center)
                    v-flex.pa-0.ma-0(text-xs-right)
                      span.card_check.cardCheck(v-if='this.$parent.steps_calc.step3')
                        v-icon.pt-3.pr-3(color='white') fas fa-check
                  v-card-media(src='assets/TCH-L2-7-8-9-Pagina1A-imagen3.jpg', height='146px')
                  v-card-title.titulo18Reg.text-xs-left.px-3
                    | 3. Características importantes
                  v-card-text.text-xs-left.parrafo14Book.px-3.py-0
                    | Personaliza los elementos clave que te ayudarán a tener más claro el panorama a la hora de comparar ofertas.
                v-layout.pb-4.btn_cards(row, justify-center, align-baseline)
                  v-btn.btn(color='secondary ', :disabled='!this.$parent.steps_calc.step2', @click.prevent="nextPage( 'page8-3') ") Personalizar
            v-spacer.py-3
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button ', color='accent ', :disabled='!this.$parent.steps_calc.step3', @click.prevent="nextPage( 'page8-4') ")
                | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false,
      steps: [{
        name: "Validar"
      }, {
        name: "Obtener"
      }, {
        name: "Descubrir"
      }]
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    }
  },
  computed: {
    currentStep: function() {
      this.steps[0].submitted = this.$parent.steps_calc.step1
      this.steps[1].available = this.steps[0].submitted
      this.steps[1].submitted = this.$parent.steps_calc.step2
      this.steps[2].available = this.steps[1].submitted
      this.steps[2].submitted = this.$parent.steps_calc.step3
      return true;
    }
  }
};
</script>
